// /admin/v1/ad-accounts + /admin/v1/event-rules — attribution config.

import { del, list, patch, post, put } from './client';
import type { ListResult } from './client';

export type AdPlatform = 'oceanengine' | 'wechat_ads' | 'douyin' | 'tencent_ads' | string;

export type AdAccountStatus = 'active' | 'paused' | 'archived';

export interface AdAccount {
  id: string;
  name: string;
  platform: AdPlatform;
  external_account_id?: string;
  status: AdAccountStatus;
  price_group_id?: number | null;
  daily_budget_cents?: number;
  notes?: string;
  created_at?: string;
  updated_at?: string;
}

export interface ListAdAccountsQuery {
  q?: string;
  platform?: AdPlatform;
  status?: AdAccountStatus;
  page?: number;
  page_size?: number;
}

export function listAdAccounts(
  q: ListAdAccountsQuery = {},
): Promise<ListResult<AdAccount>> {
  return list<AdAccount>('/admin/v1/ad-accounts', q);
}

export interface UpsertAdAccountInput {
  name?: string;
  platform?: AdPlatform;
  external_account_id?: string;
  price_group_id?: number | null;
  daily_budget_cents?: number;
  notes?: string;
  // Sent on create only — server stores AES-encrypted.
  auth_blob?: Record<string, unknown>;
}

export function createAdAccount(body: UpsertAdAccountInput & { name: string; platform: AdPlatform }): Promise<AdAccount> {
  return post<AdAccount>('/admin/v1/ad-accounts', body);
}

export function updateAdAccount(id: string, body: UpsertAdAccountInput): Promise<AdAccount> {
  return patch<AdAccount>(`/admin/v1/ad-accounts/${id}`, body);
}

export function deleteAdAccount(id: string): Promise<void> {
  return del(`/admin/v1/ad-accounts/${id}`);
}

// --- event rules ----------------------------------------------------------

export interface EventRule {
  app_id: number;
  event_kind: string;
  threshold_cents?: number;
  enabled: boolean;
  ad_account_id?: string;
  updated_at?: string;
}

export function listEventRules(appId: number): Promise<ListResult<EventRule>> {
  return list<EventRule>(`/admin/v1/event-rules/${appId}`);
}

export function upsertEventRule(appId: number, body: Omit<EventRule, 'app_id' | 'updated_at'>): Promise<EventRule> {
  return put<EventRule>(`/admin/v1/event-rules/${appId}`, body);
}
